import { IserverAddresses } from '../../types/general';

export const serverAdressesDev: IserverAddresses = {
  authServer: 'http://localhost:3201/api/',
  chatServer: 'http://localhost:3202/',
  commerceServer: 'http://localhost:3203/api/',
  managerServer: 'http://localhost:3204/api/',
  notifServer: 'http://localhost:3205/api/',
  webMetricsServer: 'https://webmetricsserver.eagleinfosolutions.com/',
  mailMetricsServer: 'https://mailmetricsserver.eagleinfosolutions.com/',
  dnsServer: 'http://localhost:9002/api/',
  mailServer: 'http://localhost:9000/api/'
};